module.exports = __webpack_public_path__ + "img/worm-preparing-02.46ecb734.png";